import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TokenActions, UserActions, SnackbarActions, CountryActions } from 'actionsets'
import StyleSheet, { AppStyles } from 'styles'
import { Link } from 'react-router-dom'
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import {CenteredCard, PasswordStrength} from 'components'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import { AutoSuggest } from 'components'
import {eventKeyMatches, KEYS} from 'utils'

export class SignUp extends Component{

  constructor(props){
    super(props)
    TokenActions.bindActions(this)
    UserActions.bindActions(this)
    CountryActions.bindActions(this, 'country')
    SnackbarActions.bindActions(this, 'snackbar')
    this.state = {result: {score: 0}}
  }

  componentDidMount(){
    this.actions.clearErrors()
  }

  setEmail = ({target: { value: email}}) => {
    this.setState({email})
  }

  setName = ({target: { value: name}}) => {
    this.setState({name})
  }

  setCountry = ({target: { value }}) => {
    this.setState({countryId: value && value.id})
  }

  setPassword = ({target: { value: password}}) => {
    this.setState({password})
  }

  setPasswordConfirmation = ({target: { value: passwordConfirmation}}) => {
    this.setState({passwordConfirmation})
  }

  signUp = async () => {
    try{
      await this.actions.create(this.state)
      this.props.history.push('/awaiting_confirmation')
      this.actions.snackbar.success('Signed up succesfully')
    }catch(err){
      if (err.status === 412)
        this.props.history.push(`/tokens/resend_invitation?email=${this.state.email}`)
      else
        this.actions.snackbar.error('Sign up failed')
    }
  }

  linkedInAuthorized = async (credentials) => {
    try{
      await this.actions.createLinkedin(credentials)
      this.props.history.push('/awaiting_confirmation')
      const location = (this.props.savedLocation && !this.props.savedLocation.match(/^\/?tokens\//)) ?
        this.props.savedLocation :
        '/'
      this.props.history.push(location)
      this.actions.snackbar.success('Signed up succesfully')
    }catch(err){
      this.actions.snackbar.error('Sign up failed')
    }
  }

  provideCountries = query => this.actions.country.search(query)

  renderError = () =>
    <Typography className={styles.error} variant='body2'>
      {this.props.errors.create.title}
    </Typography>

  getError = (errorName) =>{
    const error = this.props.errors.create && Object.entries(this.props.errors.create.meta || {}).find(([attribute, value]) => attribute === errorName)
    return error ? error[1][0] : false
  }

  render = () =>
    <CenteredCard
        className={styles.card}
      >
      <CardContent className={styles.content} onKeyUp={(e) => eventKeyMatches(e, KEYS.enter) && this.signUp()}>
        <Typography variant='h6'>Sign Up</Typography>
        {this.props.errors.create && <p className={styles.error}>{this.renderError()}</p>}

        <TextField
          error={this.getError('name')}
          helperText={this.getError('name')}
          label='Full name'
          type='text'
          onChange={this.setName}
          fullWidth
          margin="normal"
        />
        <AutoSuggest
          labelProvider={(({name: label}) => label)}
          label='Country'
          error={this.getError('countryId')}
          helperText={this.getError('countryId')}
          attribute='country'
          fullWidth
          margin="normal"
          onChange={this.setCountry}
          onSuggestionsFetchRequested={(text, callback, error) => this.provideCountries(text).then(callback).catch(error)}
        />
        <TextField
          error={this.getError('email')}
          helperText={this.getError('email')}
          label='Email address'
          type='email'
          onChange={this.setEmail}
          fullWidth
          margin="normal"
        />
        <TextField
          error={this.getError('password')}
          helperText={this.getError('password')}
          label='Password'
          type='password'
          onChange={this.setPassword}
          ref={this.focusPasswordInput}
          fullWidth
          margin="normal"
        />
        <PasswordStrength password={this.state.password} minScore={2}/>
        <TextField
          error={this.getError('passwordConfirmation')}
          helperText={this.getError('passwordConfirmation')}
          label='Password again'
          type='password'
          onChange={this.setPasswordConfirmation}
          fullWidth
          margin="normal"
        />
      </CardContent>
      <CardActions className={styles.actions}>
        <Button fullWidth className={styles.button} variant='contained' color="primary" onClick={this.signUp}>Sign up</Button>
        <Link className={[AppStyles.link, styles.navBeneath].join(' ')} to='/tokens/resend_confirmation'>Resend Confirmation Email</Link>
        <Link className={[AppStyles.link, styles.navBeneath]} to='/tokens/sign_in'>Already a member? Sign in here!</Link>
      </CardActions>
    </CenteredCard>
}

const styles = StyleSheet({
  error: {
    color: '#EA5142'
  },
  button:{
    margin: 0,
    paddingLeft: 30,
    paddingRight: 30,
  },
  linkedIn: {
    marginTop: 30
  },
  card: {
    padding: 15
  },
  actions: {
    flexWrap: 'wrap',
    paddingLeft: 16,
    paddingRight: 16,
    height: 'auto'
  },
  content: {
    display: 'flex',
    flexDirection: 'column'
  },
  resend: {
    textDecoration: 'none',
    margin: '25px 0',
    flex: '0 auto',
    minWidth: 275,
    textAlign: 'left'
  },
  navBeneath: {
    color: '#b9b39b',
    fontSize: 14,
    marginTop: 15,
    textAlign: 'center',
    width: '100%'
  },
})

export default connect(({users}) => users)(SignUp)